import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Bio.css";

function Bio() {
	useEffect(() => {
		AOS.init({
			duration: 800,
			once: true,
		});
	}, []);

	return (
		<div className="bio-container">
			{/* Left Brace */}
			<div className="brace">{'{'}</div>

			{/* Bio Section */}
			<div className="bio-section" data-aos="fade-up">
				<div className="quote">
					<p className="bio-subtext">
						Hi, I’m Ryan—a full-stack software engineer specializing in
						<span className="highlight"> JavaScript, React, and Node.js</span>.
					</p>
					<p className="bio-subtext">
						I love building web apps, solving problems, and constantly learning. Outside of coding,
						I enjoy photography, design, and boba.
					</p>
				</div>
			</div>

			{/* Right Brace */}
			<div className="brace">{'}'}</div>

			{/* Download Resume Button */}
			<div className="button-container" data-aos="zoom-in">
				<a
					href="/RMB-Resume.pdf"
					download="ryan-bartolome-resume.pdf"
					className="resume-button"
				>
					Download Resume
				</a>
			</div>

			{/* Experience Section */}
			<div className="experience-section">
				<h2 className="experience-title" data-aos="fade-up">experience</h2>

				<div className="experience-card" data-aos="fade-up" data-aos-delay="100">
					<h3>Software Engineering Experience (Training & Projects)</h3>
					<p className="company"></p>
					<p className="date">Apr 2024 – Present | Remote</p>
					<ul>
						<li>Built full-stack web applications using JavaScript, React, Node.js, Express, and PostgreSQL</li>
						<li>Designed REST APIs, relational schemas, and authentication flows</li>
						<li>Emphasized clean code, testing, and real-world problem solving over tutorials</li>
						<li>Continuing formal education in Computer Science</li>
					</ul>
				</div>

				<div className="experience-card" data-aos="fade-up" data-aos-delay="200">
					<h3>Transportation Security Officer</h3>
					<p className="company">Transportation Security Administration</p>
					<p className="date">Nov 2018 – Present | Kahului, HI</p>
					<ul>
						<li>Trusted with high-security processes in a compliance-heavy federal environment</li>
						<li>Demonstrated consistent attention to detail and adherence to SOPs</li>
						<li>Developed strong skills in workflow precision and secure operations</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export default Bio;
